module.exports = function getBytesRemaining(fileProgress) {
  return fileProgress.bytesTotal - fileProgress.bytesUploaded;
};


// WEBPACK FOOTER //
// ../node_modules/@uppy/utils/lib/getBytesRemaining.js